import { useDefinirEquipeObraDialog } from "./use-definir-equipe-obra";
import { DefinirEquipeObraDialogView } from "./view-definir-equipe-obra";
import type { DefinirEquipeObraDialogProps } from "./types-definir-equipe-obra";

/**
 * Modal "Definir Equipe de Obra". Dois modos sobre o mesmo layout:
 * - criação (`equipeDefinida` falso): monta a equipe no cliente e grava tudo num único POST;
 * - edição (`equipeDefinida` verdadeiro): lista a equipe gravada e altera só as datas,
 *   enviando um PATCH por linha alterada.
 */
export function DefinirEquipeObraDialog(props: DefinirEquipeObraDialogProps) {
  const vm = useDefinirEquipeObraDialog(props);

  return <DefinirEquipeObraDialogView {...props} {...vm} />;
}

export type * from "./types-definir-equipe-obra";
